module.exports = __webpack_public_path__ + "static/vine-84d32b97deb359c45c6e6fb9f14e846c.png";